import { createSessionStorage } from '@/services/storage/storage-service';

// todo сюда можно перенести логику хранения списка номеров заказов
export class OrdersStorage {
  constructor(storage = createSessionStorage()) {
    this.storage = storage;
  }

  get ordersWithFps() {
    return this.storage.getItem('fps-orders') || {};
  }

  set ordersWithFps(data) {
    this.storage.setItem('fps-orders', data);
  }

  removeOrderWithFps(orderNumber) {
    const fpsOrders = this.ordersWithFps;
    if (!fpsOrders) return;
    delete fpsOrders[orderNumber];
    this.ordersWithFps = fpsOrders;
  }

  updateOrderWithFps(orderNumber, data) {
    this.ordersWithFps = { ...this.ordersWithFps, [orderNumber]: data };
  }
}

export const createOrdersSessionStorage = () => new OrdersStorage();
